import { Epic } from "redux-observable";
import { switchMap, filter } from "rxjs/operators";
import { Observable } from "rxjs";
import { IState, Dependencies } from "../@types";
import { RootAction } from "../actions";
import { isActionOf } from "typesafe-actions";
import { clientsActions, clientsActionsAsync } from "../actions/clientsActions";
import { Auth } from "aws-amplify";


export const createClientEpic: Epic<
    RootAction,
    RootAction,
    IState,
    Dependencies
> = (action$, state$, dependencies) => {
    return action$.pipe(
        filter(isActionOf(clientsActionsAsync.createClient.request)),
        switchMap(action => {
            return new Observable<RootAction>(observer => {
                const state = state$.value as IState;
                const { apiGatewayUrl } = state.constants;
                const { clientName } = action.payload;
                async function createClient() {
                    const session = await Auth.currentSession();
                    const token = session.getIdToken().getJwtToken();

                    const client = await dependencies.clientsApi.createClient({
                        apiGatewayUrl,
                        token,
                        clientName,
                    });
                    observer.next(clientsActionsAsync.createClient.success({ client }));
                }
                createClient().catch(error => {
                    console.log(error);
                    observer.next(clientsActionsAsync.createClient.failure({ error }));
                });
            });
        })
    );
}